/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { Add, Edit, MoreHoriz } from "@mui/icons-material";



import { Avatar, Box, Chip, CircularProgress, IconButton, Switch, Typography } from "@mui/material";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";



import { ShowImage } from "./common/index.js";
import DateDisplay from "./common/date.jsx";


import { useTableRowActions } from "../api/use-table-row-actions.js";

const TableCelldata = ({
  row,
  item,
  rows,
  setAllRows,
  editApi,
  editInputApi,
}) => {
  const { themeColor } = useSelector((state) => state.themeColor);

  function objStyle(i) {
    if (themeColor === "dark") {
      if (i.styleDark) {
        var jsonStr = i.styleDark.replace(/(\w+:)|(\w+ :)/g, function (s) {
          return '"' + s.substring(0, s.length - 1) + '":';
        });

        return JSON.parse(jsonStr);
      } else {
        return {};
      }
    } else {
      if (i.style) {
        var jsonStrW = i.style.replace(/(\w+:)|(\w+ :)/g, function (s) {
          return '"' + s.substring(0, s.length - 1) + '":';
        });

        return JSON.parse(jsonStrW);
      } else {
        return {};
      }
    }
  }
  const navigate = useNavigate();
  const { loading, handleActive, handleInput } = useTableRowActions({ row, rows, setAllRows, editApi, editInputApi });
  return (
    <Box sx={objStyle(item)}>
      {item.type === "image" ? (
        <ShowImage address={row[item.name]} />
      ) : item.type === "active" ? (
        <div className="relative">
          {loading && <CircularProgress className="absolute top-2 right-0" />}

          <Switch
            disabled={loading || !editApi}
            onClick={handleActive}
            /*  color="success" */
            checked={Boolean(row[item.name])}
          />
        </div>
      ) : item.type === "date" ? (
        <>
          {" "}
          <DateDisplay date={row[item.name]} />
        </>
      ) : item.type === "price" ? (
        <>
          {" "}
          {row[item.name]?.toLocaleString()} <small>تومان</small>{" "}
        </>
      ) : item.type === "status" ? (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              /*   justifyContent: "center",
              mr: 3, */
            }}
          >
            <Box
              sx={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                background: row[item.name] ? "#2e7d32" : "#d32f2f",
                mx: 1,
              }}
            ></Box>
            {row[item.name] ? "فعال" : "غیر فعال"}
          </Box>
        </>
      ) : item.type === "qty" ? (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              /*   justifyContent: "center",
          mr: 3, */
            }}
          >
            <Box
              sx={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                background: row[item.name] ? "#2e7d32" : "#d32f2f",
                mx: 1,
              }}
            ></Box>
            {row[item.name] ? "موجود" : "نا موجود"}
          </Box>
        </>
      ) : item.type === "items" ? (
        <>
          {row.values?.length > 0 ? (
            <>
              {row.values?.map((val, i) => {
                if (row.values?.length < 1 || i < 1) {
                  return <Chip label={val.title} sx={{ m: "2px" }} key={i} />;
                } else if (i === 2) {
                  return <MoreHoriz sx={{ verticalAlign: "bottom" }} />;
                } else {
                  return null;
                }
              })}
              <IconButton
                onClick={() => {
                  navigate(`/attributes/values/${row?.id}`);
                }}
              >
                <Edit color="warning" />
              </IconButton>
            </>
          ) : (
            <IconButton
              onClick={() =>
                navigate(`/attribute/values/${row?.id}`, {
                  state: {
                    rows: row?.values,
                    title: row?.title,
                    type: row?.type,
                  },
                })
              }
            >
              <Add color="success" />
            </IconButton>
          )}
        </>
      ) : item.type === "tag" ? (
        <>
          {row[item.name] && row[item.name]?.split(",") ? (
            <>
              {row[item.name]?.split(",")?.map((val, i) => {
                if (row[item.name]?.split(",")?.length < 1 || i < 1) {
                  return (
                    <Chip
                      label={row[item.name]?.split(",")[i + 1]}
                      sx={{ m: "2px" }}
                      key={i}
                    />
                  );
                } else if (i === 2) {
                  return <MoreHoriz sx={{ verticalAlign: "bottom" }} />;
                } else {
                  return null;
                }
              })}
            </>
          ) : (
            <></>
          )}
        </>
      ) : item.type === "enum" ? (
        <>
          {item.enums?.map((t, index) => (
            <Fragment key={index + t.title + "pp"}>
              {String(t.value) === String(row[item.name]) ? (
                <Box sx={objStyle(t)}>{t.title}</Box>
              ) : (
                <></>
              )}
            </Fragment>
          ))}
        </>
      ) : item.type === "attrib" ? (
        <>
          {" "}
          {row[item.name]?.type === 1 ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {!row[item.name]?.galleryId ? (
                <Avatar
                  sx={{
                    background: row[item.name]?.value,
                    border: "1px solid gray",
                    width: "18px",
                    height: "18px",
                  }}
                >
                  &nbsp;
                </Avatar>
              ) : (
                <ShowImage
                  smallImage={true}
                  address={row[item.name]?.galleryId}
                />
              )}

              {row[item.name]?.title}
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {row[item.name] && (
                <>
                  {row[item.name]?.attrib} /{row[item.name]?.title}
                </>
              )}
            </Box>
          )}
        </>
      ) : item.type === "bool" ? (
        <>
          {" "}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              /*   justifyContent: "center",
          mr: 3, */
            }}
          >
            <Box
              sx={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                background: row[item.name] ? "#2e7d32" : "#d32f2f",
                mx: 1,
              }}
            ></Box>
            {row[item.name] ? "بلی" : "خیر"}
          </Box>
        </>
      ) : item.type === "stringArray" ? (
        <>
          {" "}
          {row[item.name].length > 0 ? (
            <div className="flex gap-1 items-center justify-center">
              <MoreHoriz sx={{ verticalAlign: "bottom" }} /> ,
              {row[item.name][0]}
            </div>
          ) : (
            row[item.name][0]
          )}
        </>
      ) : item.type === "input" ? (
        <>
          <input
            type={"number"}
            className="border rounded-md h-7 w-16 px-3 py-2 bg-transparent"
            defaultValue={row[item.name]}
            onChange={(e) => handleInput(e.target.value, item.name)}
          />
        </>
      ) : item.type === "link" ? (
        <>
          {row[item.name] && (
            <Link target={"_blank"} to={`${item.link}/${row[item.name]}`}>
              <Typography
                sx={{
                  textAlign: "center",
                  p: 1,
                  background: (theme) =>
                    theme.palette.mode === "light" ? "#fdf2f2" : "#47402b",
                  width: { md: "70%", xs: "100%" },
                  cursor: "pointer",
                  fontWeight: "400 !important",
                  "&:hover": {
                    background: (theme) =>
                      theme.palette.mode === "light"
                        ? "rgb(253 224 71)"
                        : "#A75707",
                  },
                }}
                /*    component="mark" */
                variant="body2"
                className=" rounded-md"
              >
                {row[item.name]}
              </Typography>
            </Link>
          )}
        </>
      ) : item.type === "urlLink" ? (
        <>
          {row[item.name] && (
            <Typography
              href={`${process.env.REACT_APP_DOMAIN_URL}${
                item.link ? item.link : ""
              }${row[item.name]}`}
              target={"_blank"}
              rel="noreferrer"
              className="text-xs transition"
              component={"a"}
              sx={{
                textAlign: "center",
                p: "4px",
                fontSize: "0.75rem !important",
                background: (theme) =>
                  theme.palette.mode === "light" ? "#fdf2f2" : "#47402b",
                width: { md: "70%", xs: "100%" },
                cursor: "pointer",
                fontWeight: "400 !important",
                "&:hover": {
                  background: (theme) =>
                    theme.palette.mode === "light"
                      ? "rgb(253 224 71)"
                      : "#A75707",
                },
              }}
            >
              {row[item.name]}
            </Typography>
          )}
        </>
      ) : item.type === "objectfield" ? (
        <>{row[item.name]?.[item.link] ?? "—"}</>
      ) : item.type === "highLight" ? (
        <div className="border-2 rounded-md flex justify-center items-center px-3 py-1">{row[item.name]}</div>
      ) : (
        <> {row[item.name]} </>
      )}
    </Box>
  );
};

export default TableCelldata;
